import { createFileRoute } from "@tanstack/react-router";
import { EmployeesListView } from "@/features/employees";

export const Route = createFileRoute("/employees")({
	component: EmployeesListView,
});
